module.exports = "/_next/static/images/5087cb6b54da7be956925ba9b12cc701-phone-xs.png.webp";